import * as React from 'react'
import {countTotalFlowData, enumToView, filterFlowUnit} from '@src/utils';
import * as styles from '../style/index.scss';
import {FormattedMessage, FormattedPlural} from 'react-intl'
import MultiActivity from '@utils/multiActivity'
import intl from '@utils/intl';

export default ({packageDetail, preMonth}) => {
    const multiActivity = new MultiActivity(packageDetail)
    const unit = multiActivity.formatPackageValidDate().unit
    const goodsTime = multiActivity.formatPackageValidDate().goodsTime
    // 单数
    const odd = intl.formatMessage({id: `common.${unit === '0' ? 'unitMonthOdd' : 'unitDayOdd'}`})
    // 复数
    const plural = intl.formatMessage({id: `common.${unit === '0' ? 'unitMonthPlural' : 'unitDayPlural'}`})
    return (
        <div className={styles.packageBaseInfo}>
            <p className={styles.packageName}>{countTotalFlowData({
                goodsNumber: packageDetail.goodsNumber,
                policyDegree: packageDetail.policyDegree
            })}</p>
            {
                unit === '0' && goodsTime > 1 &&
                <p className={styles.perMonth}>{filterFlowUnit(packageDetail.policyDegree)}/{preMonth}</p>
            }
            <p className={styles.validTime}>
                <FormattedMessage
                    id="package.validDate"
                    values={{
                        timeLength: goodsTime,
                        dateUnit: <FormattedPlural value={goodsTime} one={odd} other={plural}/>
                    }}
                />
            </p>
            <p className={styles.price}>{enumToView('CURRENCY', packageDetail.cargoType)}{packageDetail.totalPrice}</p>
        </div>
    )
}
